<template>
  <div>
    <LeftNavigation
      :leftNavDrawer="leftNavDrawer"
      :leftNavDrawerItems="leftNavDrawerItemsFiltered"
    />
    <Toolbar v-on:toolbarSideIconClick='leftNavDrawer = !leftNavDrawer' />
  </div>
</template>

<script>
import LeftNavigation from './LeftNavigation'
import Toolbar from './Toolbar'
export default {
  name: 'Header',
  components: { LeftNavigation, Toolbar },
  computed: {
    leftNavDrawerItemsFiltered () {
      const predicate = (item) => {
        if (!this.$store.state.config.vueFrontendConfig.b4tadmin) {
          return !item.b4tAdminRequired
        }
        return true
      }
      return this.leftNavDrawerItems.filter(
        predicate
      ).map(route => {
        return { ...route, items: route.items.filter(predicate) }
      })
    }
  },
  data: () => ({
    leftNavDrawer: true,
    // Left Nav Items
    leftNavDrawerItems: [
      {
        key: 'basic-nav',
        items: [
          { title: 'Home', icon: 'home', path: '/home' },
          { title: 'Data Export', icon: 'cloud_download', path: '/export' },
          { title: 'Device Graph', icon: 'insert_chart', path: '/graph' },
          { title: 'Device Status', icon: 'speed', path: '/devicestatus' }
        ]
      },
      {
        key: 'devices',
        items: [
          { title: 'Organisations', icon: 'phonelink', path: '/organisations' },
          {
            title: 'Project Groups',
            icon: 'phonelink',
            path: '/projectgroups'
          },
          { title: 'Device Types', icon: 'phonelink', path: '/devicetypes' },
          { title: 'Devices', icon: 'phonelink', path: '/devices' }
        ]
      },
      {
        key: 'alert-actions',
        items: [
          {
            title: 'Alert Groups',
            icon: 'bolt',
            path: '/alertgroup'
          }
        ],
        b4tAdminRequired: true
      },
      {
        key: 'manifest',
        items: [
          { title: 'Group Info', icon: 'phonelink', path: '/groupinfos' },
          { title: 'Asset Info', icon: 'phonelink', path: '/assetinfos' },
          { title: 'Physical Info', icon: 'phonelink', path: '/physicalinfos' }
        ],
        b4tAdminRequired: true
      },
      // {
      //  key: 'admin',
      //  admin: true,
      //  items: [
      //    {
      //      title: 'Sigfox Dashboard',
      //      icon: 'monitor',
      //      path: '/sigfox_dashboard'
      //    }
      //  ]
      // },
      {
        key: 'account',
        items: [
          { title: 'Account', icon: 'perm_identity', path: '/account', b4tAdminRequired: true },
          { title: 'Logout', icon: 'exit_to_app', path: '/logout' }
        ]
      }
    ]
  })
}
</script>
